const INITIAL_STATE = {
  localDatasetAssetMetering: null,
  loadingDatasetAssetMetering: false,
};

const uploadAssetMeteringReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Dataset Asset Metering
    case "DATASET_ASSET_METERING_CHANGED":
      return {
        ...state,
        localDatasetAssetMetering: action.payload
      };

    case "UPLOAD_DATASET_ASSET_METERING_START":
      return {
        ...state,
        loadingDatasetAssetMetering: true
      };

    case "UPLOAD_DATASET_ASSET_METERING_SUCCESS":
      return {
        ...state,
        loadingDatasetAssetMetering: false
      };

    case "UPLOAD_DATASET_ASSET_METERING_FAIL":
      return {
        ...state,
        loadingDatasetAssetMetering: false
      };

    default:
      return state
  }
}

export default uploadAssetMeteringReducer;


// WEBPACK FOOTER //
// ./src/reducers/Maintenance/uploadAssetMeteringReducer.js